const mobiles = [
  /Android/i,
  /webOS/i,
  /iPhone/i,
  /iPad/i,
  /iPod/i,
  /BlackBerry/i,
  /Windows Phone/i,
];

export const isMobile = () => mobiles.some((el) => navigator.userAgent.match(el));
